// extracted by mini-css-extract-plugin
export default {"link":"CL-z","disabled":"DL-z"};